
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#F07300"}}),_c('path',{attrs:{"d":"M13.391 20.823h1.173v1.714h-1.173v2.316h-2.055v-2.316H7.092L7 21.199l4.315-7.052h2.076v6.676zm-4.344 0h2.29v-3.779l-.136.243-2.154 3.537zM22.64 20.427c0 1.48-.296 2.612-.889 3.396-.592.785-1.46 1.177-2.602 1.177-1.128 0-1.99-.385-2.587-1.154-.598-.77-.903-1.873-.917-3.31v-1.97c0-1.495.298-2.63.895-3.404.602-.775 1.467-1.162 2.595-1.162 1.128 0 1.99.385 2.588 1.154.597.765.903 1.866.917 3.302v1.97zm-2.055-2.162c0-.887-.118-1.532-.355-1.934-.232-.407-.597-.61-1.095-.61-.483 0-.841.193-1.073.58-.228.383-.349.983-.363 1.802v2.603c0 .872.114 1.522.341 1.948.233.422.602.633 1.11.633.502 0 .864-.204 1.087-.61.223-.407.339-1.03.348-1.868v-2.544zM30.327 20.823H31.5v1.714h-1.173v2.316h-2.055v-2.316h-4.244l-.092-1.339 4.315-7.051h2.076v6.676zm-4.344 0h2.29v-3.779l-.136.243-2.154 3.536z","fill":"#fff"}})])
          )
        }
      }
    